import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import PlayerAvatar from './player-avatar';
import { players } from '../../constants/images';

/**
 * @class Player
 *
 * @description
 * Class for the individual player component.
 *
 * @example
 * <Player />
 */
@connect(
	state => ({
	})
)
export default class Player extends Component {

	static PropTypes = {
		isPlayerActive: PropTypes.bool,
		isPlayerCharacter: PropTypes.bool,
		delayTransition: PropTypes.bool,
		resources: PropTypes.number,
		countryCode: PropTypes.string
	};

	/**
	 * @constructor
	 *
	 * @param {Object} props
	 */
	constructor (props) {
		super(props);

		this.state = {
			radius: 53,
			maxResources: 150000,
			successfulDockResources: 50000
		}
	}

	progress (percentage) {
		// to show green border around the player avatar when a player is being introduced
		if (this.props.isPlayerActive && this.props.isPlayerActive !== 'default' && this.props.activeStepId === 'players-intro') {
			return {
				'strokeDashoffset': 1,
				'strokeDasharray': 0,
				'stroke': '#7fc242',
			}
		}

		let circumference = 2 * Math.PI * this.state.radius;
		let progress = percentage / this.state.maxResources;
		let dashoffset = circumference * (1 - progress);
		return {
			'strokeDashoffset': dashoffset,
			'strokeDasharray': circumference,
			'stroke': this.props.resources > this.state.successfulDockResources ? '#7fc242' : '#f6ee25'
		}
	}

	getPlayerImage () {
		let playerImage;
		if (this.props.isPlayerCharacter) {
			playerImage = <PlayerAvatar />;
		} else {
			playerImage = (
				<div className={"player__progress-wrap"}>
					<img className="player__progress__logo"
							 src={players[this.props.img]}
							 alt="" />
				</div>
			);
		}
		return playerImage
	}

	getPlayerClasses () {
		let classes = 'player';

		if (this.props.delayTransition) {
			classes += ' player--delayed';
		}

		if (this.props.isPlayerActive && this.props.isPlayerActive !== 'default') {
			classes += ' player--active';
		}

		if (!this.props.isPlayerActive) {
			classes += ' player--inactive';
		}

		return classes;
	}

	/**
	 * @description
	 * Component Method
	 * Renders a component
	 *
	 * @returns {ReactElement} component
	 */
	render () {
		const { resources, name, role, countryCode } = this.props;

		const translatedRole = role[countryCode];
		const translatedName = name[countryCode];

		return (
			<div className={this.getPlayerClasses()}>
				<div className="player__progress">
					<svg width="120"
							 height="120"
							 viewBox="0 0 120 120">
						<circle className="player__progress__value"
										style={this.progress(resources)}
										cx="60"
										cy="60"
										r={this.state.radius}
										strokeWidth="15" />
					</svg>
					{this.getPlayerImage()}
					<div className="player__goal" />
				</div>
				<div className="player-role">
					<strong>{translatedName}</strong><br />
					{translatedRole}<br />
					€{resources}
				</div>
			</div>
		);
	}
}
